import { api } from './api/axiosInstance';
import { API_ENDPOINTS, buildUrl } from './api/endpoints';

const { REPORTS } = API_ENDPOINTS;

export const ReportService = {
  generate:   (payload)        => api.post(REPORTS.GENERATE, payload),
  list:       (params)         => api.get(buildUrl(REPORTS.BASE, params)),
  detail:     (id)             => api.get(REPORTS.DETAIL(id)),
  rows:       (id, page, limit) => api.get(buildUrl(REPORTS.ROWS(id), { page, limit })),
  download:   (id, format)     => api.get(buildUrl(REPORTS.DOWNLOAD(id), { format }), { responseType: 'blob' }),
  delete:     (id)             => api.delete(REPORTS.DELETE(id)),
  regenerate: (id)             => api.post(REPORTS.REGENERATE(id)),
};
